import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, inject, signal } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { fadeInOut } from '@core/animations'
import { PalantirButtonComponent, PalantirButtonTheme } from '@fieldcontrol/palantir'
import { TranslateModule } from '@ngx-translate/core'
import { Subject, takeUntil } from 'rxjs'
import { FcMenuService } from './fc-menu.service'
import { DirectivesModule } from '../../directives/directives.module'

@Component({
    selector: 'fc-menu',
    templateUrl: './fc-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        fadeInOut
    ],
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        CommonModule,
        TranslateModule,
        DirectivesModule,
        PalantirButtonComponent
    ]
})
export class FcMenuComponent implements OnInit, OnDestroy {
  @Input({ required: true })
  public title!: string

  @Input({ required: false })
  public theme: PalantirButtonTheme = 'solid'

  @Input({ required: false })
  public size: string = 'base'

  @Input({ required: false })
  public position =  'left-0'

  public fcMenuService = inject(FcMenuService)
  public destroy$ = new Subject<void>()
  public showMenu = signal(false)

  public ngOnInit(): void {
    this.showMenu.set(false)
    this.fcMenuService.close$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showMenu.set(false)
      })
  }

  public ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  public toggle(): void {
    const show = !this.showMenu()
    this.fcMenuService.close$.next()
    this.showMenu.set(show)
  }
}
